import {Button, DatePicker, Flex, Form, Input, Popover, Select, Typography} from "antd";
import {useForm} from "antd/es/form/Form";
import {GrCircleQuestion} from "react-icons/gr";
import React, {useEffect, useState} from "react";
import UploadDoc from "../component/UploadDoc";
import {resultStore} from "../../../store/admissions/admissionStore";
import {userStore} from "../../../store/store";
import {getRequest} from "../../../api/httpRequest";
import {stepsStore} from "../../../store/admissions/stepperStore";
import dayjs from "dayjs";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {UploadChangeParam} from "antd/es/upload";

interface ICountry {
    Code: string,
    Name: string,
    FullName: string,
    alpha2: string,
    InternationalName: string
}

export default function Step5() {
    const {stepsData, setStepsData} = stepsStore();
    const [form] = useForm();
    const {result, setResult} = resultStore();
    const {user} = userStore();
    const [countries, setCountries] = useState<ICountry[]>([]);
    const {xl} = useBreakpoint()
    const [uploaded, setUploaded] = useState<Set<string>>(new Set<string>());

    useEffect(() => {
        getRequest("/server/proxy/contracts/countries")
            .then((res: any) => {
                setCountries(res.data);
            })
        setResult({
            ...result,
            name: user.firstName ? user.firstName : "",
            patronymic: user.middleName ? user.middleName : "",
            surname: user.lastName ? user.lastName : "",
            snils: user.snils ? user.snils : "",
            telephone: user.phone ? user.phone : "",
            birthdate: user.birth ? user.birth : "",
            citizenship: user.country ? user.country : "",
            email: user.email ? user.email : "",
            gender: user.gender ? user.gender : "",
        })
        setStepsData({...stepsData, nextStep: true})
    }, []);

    const onFileChange = (file: UploadChangeParam, name: string | undefined) => {
        if (file.file.status === "done" && name !== undefined) {
            const newSet = new Set(uploaded);
            newSet.add(name)
        }
    }

    function UploadItem(props: any) {
        return (
            <Flex gap={24} style={{width: "100%"}}>
                <Flex style={{width: "50%"}} justify={"flex-end"} align={"center"}>
                    <Typography.Text>{props.title}</Typography.Text>
                </Flex>
                <Flex style={{width: "50%"}} align={"center"} justify={"flex-start"} gap={16}>
                    <UploadDoc id={props.title} onFileChange={onFileChange}
                               filesToDone={["Главный разворот паспорта"]}/>
                    <Popover title={props.help}
                             placement={"right"}
                             trigger="hover">
                        <Button type={"text"} icon={<GrCircleQuestion/>}/>
                    </Popover>
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex vertical style={{width: '100%'}} justify={"center"} align={"center"} gap={16}>
            <Typography.Text strong style={{fontSize: "20px", paddingBottom: "20px"}}>Введите персональные
                данные</Typography.Text>
            <Form
                form={form}
                style={{width: xl ? "800px" : "100%"}}
                initialValues={{
                    lastName: user.lastName,
                    firstName: user.firstName,
                    middleName: user.middleName,
                    snils: user.snils?.replaceAll("-", "").replaceAll(" ", ""),
                    sex: user.gender,
                    birthday: dayjs(user.birth),
                    phone: user.phone,
                    email: user.email,
                    country: user.country,
                }}
                name="documents"
                size={xl ? "small" : "large"}
                labelCol={{span: 7}}
                requiredMark={false}
            >
                <Flex style={{width: "100%"}} gap={xl ? 16 : 0} vertical={!xl}>
                    <Flex style={{width: "100%"}} vertical={true}>
                        <Form.Item
                            label="Фамилия"
                            name="lastName"
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                        <Form.Item
                            label="Имя"
                            name="firstName"
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                        <Form.Item
                            label="Отчество"
                            name="middleName"
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                        {user.country === "643" &&
                            <Form.Item
                                label="Снилс"
                                name="snils"
                            >
                                <Input.OTP
                                    disabled={true}
                                    length={11}
                                    separator={(i) => {
                                        return ((i === 2 || i === 5 || i === 8) &&
                                            <div style={{width: "5px", height: "2px", backgroundColor: "lightgray"}}/>)
                                    }}
                                />
                            </Form.Item>
                        }
                    </Flex>
                    <Flex style={{width: "100%"}} vertical={true}>
                        <Form.Item
                            label="Пол"
                            name="sex"
                        >
                            <Select
                                disabled={true}
                                popupMatchSelectWidth
                                options={[
                                    {
                                        label: `Мужской`,
                                        value: `1`
                                    },
                                    {
                                        label: `Женский`,
                                        value: `0`
                                    }
                                ]
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Дата рождения"
                            name="birthday"
                        >
                            <DatePicker disabled={true}/>
                        </Form.Item>
                        <Form.Item
                            label="Телефон"
                            name="phone"
                        >
                            <Input addonBefore={"+"} disabled={true}/>
                        </Form.Item>
                        <Form.Item
                            label="Почта"
                            name="email"
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                        <Form.Item
                            label="Гражданство"
                            name="country"
                        >
                            <Select
                                disabled={true}
                                options={countries.map((country: ICountry) => (
                                    {
                                        value: country.Code,
                                        label: country.Name
                                    }
                                ))}
                            />
                        </Form.Item>
                    </Flex>
                </Flex>
            </Form>
            <Typography.Text style={{fontSize: "20px"}} strong={true}>Загрузите документы</Typography.Text>
            <Typography.Text>Можно загрузить файлы формата .pdf, .jpg, .jpeg, .png и .zip размером до
                5мб</Typography.Text>
            <Flex
                style={{width: xl ? "70%" : "100%"}}
                justify={"center"}
                align={"center"}
                vertical={true}
                gap={16}
            >
                {user.country === "643" ?
                    <>
                        <UploadItem title={"Главный разворот паспорта"} help={"Загрузите 2 и 3 страницу паспорта"}/>
                        <UploadItem title={"Место жительства"} help={"Загрузите 5 страницу паспорта"}/>
                        <UploadItem title={"Сведение о ранее выданных паспортах"}
                                    help={"Загрузите 19 страницу паспорта"}/>
                        <UploadItem title={"СНИЛС"} help={"Загрузите копию СНИЛС"}/>
                    </>
                    :
                    <>
                        <UploadItem title={"Документ, удостоверяющий личность"}
                                    help={"Для иностранных документов, необходимо загрузить копии нотариально-заверенного перевода на русский язык"}/>
                        <UploadItem title={"Место жительства"} help={"Копии временной регистрации РФ (с 2-ух сторон РФ) или копии нотариально-заверенного перевода на русский язык документа, подтверждающего регистрацию за пределами РФ"}/>
                    </>
                }
            </Flex>
        </Flex>
    )
}